export const ERR_MSG = {
  NO_PERM : 'Je nám líto, ale nemáte oprávnění zobrazit tento formulář.',
  NO_EXIST: 'Je nám líto, ale tento formulář neexistuje.',
  UNKNOWN:  'Je nám líto, ale nepodařilo se načíst data do formuláře. Zkuste to prosím později.',
}